module.exports = __webpack_public_path__ + "static/media/Twitter.0e6d35f5.svg";